import { useEffect, useRef } from "react";

// Calls `callback` every `interval` ms (only when tab is visible) and immediately
// whenever the tab/window regains focus. Keeps data fresh without manual refresh.
export function usePolling(callback, interval = 15000) {
  const cb = useRef(callback);
  cb.current = callback;

  useEffect(() => {
    const tick = () => {
      if (document.visibilityState === "visible") cb.current();
    };
    const id = setInterval(tick, interval);
    const onFocus = () => cb.current();
    const onVisible = () => {
      if (document.visibilityState === "visible") cb.current();
    };
    window.addEventListener("focus", onFocus);
    document.addEventListener("visibilitychange", onVisible);
    return () => {
      clearInterval(id);
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, [interval]);
}
